module.exports = __webpack_public_path__ + "img/archimede.f61792fe.png";